export { IconArrowBack } from "./IconArrowBack";
